import { useRouteError } from 'react-router';
import * as Sentry from '@sentry/react';
import { useEffect } from 'react';

const SentryErrorBoundary = () => {
  const error = useRouteError() as Error;

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <div>
      <h1>Ouch!</h1>
    </div>
  );
};

export default SentryErrorBoundary;
